import React from 'react';
import LiceList from "../../../../components/Operation/LiceList";
import AttachFile from "../../../../components/Popup/PopupOpInfo/_component/AttachFile";
import Tasks from "../../../../components/Popup/PopupOpInfo/Info/Treatment/Tasks2";
import { useSelector } from '../../../../util/store/store';
import { IOperation2, ITreatment2 } from "../../../../util/varibles/interface";
import FishDisease from "../../_components/FishDisease";

import DeadFish from '../../../../components/Operation/DeadFish';
import LiceReduction from '../../../../components/Operation/LiceReduction';
import MortalityIncrease from '../../../../components/Operation/MortalityIncrease';
import StatusGrading from '../../../../components/Operation/StatusGrading';
import { WeatherFull } from '../../../../components/Operation/Weather';
import OperationMetricsTooltip from '../../../../components/Tooltip/OperationMetricsTooltip';
import { OP_STATUS } from '../../../../util/varibles/constants';
import Checklists from "../../_components/Checklists";
import Operation from "../../_components/Operation";
import stylesOp from "../../_components/Operation/style.module.scss";
import OperationCost from '../../_components/OperationCost';
import OperationTime from "../../_components/OperationTime";
import Route from "../../_components/Route";
import Vessel from "../../_components/Vessel";
import ViewNote from "../../_components/ViewNote";
import { selectOpDetail } from '../../constants';
import stylesContainer from "../../style.module.scss";
import ActivityLog from './ActivityLog';

interface IProps {
    data: IOperation2<ITreatment2>
    isOwn: boolean
}

const Treatment: React.FC<IProps> = ({ data, isOwn }) => {
    const infoMode = useSelector(selectOpDetail.infoMode);
    const {
        note = '',
        files = [],
        sub_operations,
        real_sub_operations,
        dead_fish,
        status,
        mortality_increase,
        lice_reduction,
    } = data.operation;
    const isNote = note.length === 0;
    const totalFishAmount = (real_sub_operations ?? []).reduce(
        (total, subOperation) => total + (subOperation.fish_amount ?? 0),
        0,
    );

    const { activity_log } = data;

    return <div className='col-span-2 pb-3'>
        <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
            <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                <Operation {...{ isNote }}>
                    <OperationTime activity_log={activity_log} mode={infoMode} />
                    <WeatherFull operation={data.operation} />
                    <div className={stylesOp['info-line']}>
                        <AttachFile files={files} />
                    </div>
                    <FishDisease diseases={data.operation.diseases || []} units={sub_operations} />
                    <LiceList diseases={data.operation.diseases || []} />
                    <div className='mt-3'>
                        <Tasks data={data.operation} infoMode={infoMode} />
                    </div>
                    <ViewNote data={data} isOwn={isOwn} note={note} />
                </Operation>
            </div>
            <div className='grid min-w-0 grid-rows-[auto_minmax(0,1fr)] gap-[15px] [&>div]:mb-0 [&>div]:w-full [&>div:last-child]:!h-full'>
                <div className={stylesContainer.section}>
                    <div className={`${stylesContainer['header-box']} flex items-center justify-between`}>
                        <span className='text-[15px] font-[600]'>Treatment grading</span>
                        <OperationMetricsTooltip placement='bottomRight' />
                    </div>
                    <div className='flex flex-col items-center [&>div:not(:first-child)]:h-[55px] [&>div:not(:first-child)]:justify-center'>
                        <StatusGrading operation={data.operation} />
                        <LiceReduction
                            value={lice_reduction}
                            valueClassName='text-[20px]'
                            showDetails={false}
                            layout='vertical'
                        />
                        <MortalityIncrease
                            value={mortality_increase}
                            valueClassName='text-[20px]'
                            layout='vertical'
                        />
                        <DeadFish
                            value={dead_fish}
                            total={totalFishAmount}
                            valueClassName='text-[20px]'
                            layout='vertical'
                            label='Σ Dead fish'
                            showPercent={status === OP_STATUS.FINISHED}
                        />
                    </div>
                </div>
                <Checklists isNewChecklistView />
            </div>
        </div>
        <div className='min-w-0 [&>div]:w-full mb-[15px]'>
            <OperationCost operation={data.operation} vesselId={data.vessel.id} />
        </div>
        <div className='min-w-0 [&>div]:w-full mb-[15px]'>
            <Vessel />
        </div>
        <div className={`mb-[15px]`}>
            <div className="flex w-full align-items-center justify-center">
                <span className="my-2 text-[20px]">Activity log</span>
            </div>
            <ActivityLog data={data} />
        </div>
        <Route />
    </div>;
};

export default Treatment;
